<template>
  <div class="container">
    <header class="header">
      <router-link :to="{ name: 'Home', params: { lang: $route.params.lang } }" class="title">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
        {{ $t('backBtn') }}
      </router-link>
      <div class="lang">
        <router-link class="lang__item" :class="{ active: $route.params.lang === 'uz' }"
          :to="{ name: 'Profil', params: { lang: 'uz' } }">
          <img class="img" :src="linkImg + '/img/041-uzbekistan.png'" alt="" />
        </router-link>
        <router-link class="lang__item" :class="{ active: $route.params.lang === 'ru' }"
          :to="{ name: 'Profil', params: { lang: 'ru' } }">
          <img class="img" :src="linkImg + '/img/044-russia.png'" alt="" />
        </router-link>
        <router-link class="lang__item" :class="{ active: $route.params.lang === 'en' }"
          :to="{ name: 'Profil', params: { lang: 'en' } }">
          <img class="img" :src="linkImg + '/img/186-united-states.png'" alt="" />
        </router-link>
      </div>
    </header>
    <section class="history">
      <h1 class="history__title">{{ $t('prOne') }}</h1>
      <div class="history__list">
        <p v-if="eTicket.length === 0">{{ $t('empty') }}</p>
        <div v-else>
          <div class="list" v-for="item, index in eTicket" :key="index">
            <div class="list__text" @click="openEticket(item)">
              <h2 class="title">{{ item.number }}</h2>
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </div>
            <div class="list__content" v-if="show === item.number">
              <div class="status">
                <h1 class="title">{{ $t('yourTicket') }}</h1>
                <transition name="fade">
                  <p v-if="status === 0">{{ $t('statusNo') }}</p>
                  <p v-else-if="status === 1">{{ $t('statusYes') }}</p>
                  <p v-else-if="status === 2">{{ $t('statusСalled') }}</p>
                  <p v-else-if="status === 3">{{ $t('statusСlosed') }}</p>
                </transition>
              </div>
              <ul>
                <li>
                  <h1>{{ $t('number') }}</h1>
                  <h2>{{ item.number }}</h2>
                </li>
                <li>
                  <h1>{{ $t('branch') }}</h1>
                  <h2>{{ item.branch }}</h2>
                </li>
                <li>
                  <h1>{{ $t('address') }}</h1>
                  <h2>{{ item.address }}</h2>
                </li>
                <li>
                  <h1>{{ $t('service') }}</h1>
                  <h2>{{ item.serviseText }}</h2>
                </li>
                <li>
                  <h1>{{ $t('validUntil') }}</h1>
                  <h2>{{ item.validUntil }}</h2>
                </li>
              </ul>
              <a @click.prevent="deleteTicket(item)" href="" class="list__link">{{
                $t("deleteBtnET") }}</a>
              <transition name="fade">
                <div v-if="isActiveToolTip" class="list__tooltip">
                  <p>{{ $t('deteleText') }}</p>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <h2 class="history__title">{{ $t('prTwo') }}</h2>
      <div class="history__list">
        <p v-if="booking.length === 0">{{ $t('empty') }}</p>
        <div v-else>
          <div class="list" v-for="item, index in booking" :key="index">
            <div class="list__text" @click="openBooking(item)">
              <h2 class="title">{{ item.number }}</h2>
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </div>
            <div class="list__content" v-if="show === item.number">
              <div class="status">
                <h1 class="title">{{ $t('yourBoTicket') }}</h1>
                <transition name="fade">
                  <p v-if="status === 1">{{ $t('statusYes') }}</p>
                  <p v-else-if="status === 0">{{ $t('statusNo') }}</p>
                </transition>
              </div>
              <ul>
                <li>
                  <h1>{{ $t('bookingCode') }}</h1>
                  <h2>{{ item.number }}</h2>
                </li>
                <li>
                  <h1>{{ $t('branch') }}</h1>
                  <h2>{{ item.branch }}</h2>
                </li>
                <li>
                  <h1>{{ $t('address') }}</h1>
                  <h2>{{ item.address }}</h2>
                </li>
                <li>
                  <h1>{{ $t('service') }}</h1>
                  <h2>{{ item.serviseText }}</h2>
                </li>
                <li>
                  <h1>{{ $t('date') }}</h1>
                  <h2>{{ item.month }} {{ item.day }}, {{ item.year }}, {{ item.time }}</h2>
                </li>
              </ul>
              <a @click.prevent="deleteBooking(item)" href="" class="list__link">{{
                $t("deleteBtnBO") }}</a>
              <transition name="fade">
                <div v-if="isActiveToolTip" class="list__tooltip">
                  <p>{{ $t("deteleText") }}</p>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import "moment/locale/uz-latn"

export default {
  data() {
    return {
      show: 0,
      isActiveToolTip: false,
      eTicket: '',
      booking: '',
      dates: {
        day: '',
        month: '',
        year: '',
      },
      month: {
        0: "Январь",
        1: "Февраль",
        2: "Март",
        3: "Апрель",
        4: "Май",
        5: "Июнь",
        6: "Июль",
        7: "Август",
        8: "Сентябрь",
        9: "Октябрь",
        10: "Ноябрь",
        11: "Декабрь",
      },
      linkImg: '',
      settings: '',
      status: ''
    }
  },
  mounted() {
    this.settings = window.MY_CONFIG_EASYQ
    this.$i18n.locale = this.$route.params.lang
    this.linkImg = window.MY_CONFIG_EASYQ.linkImg
    this.loadeTicket()
    this.loadBooking()
    this.dates.month = this.month[new Date().getMonth()]
    this.dates.day = new Date().getDate()
    this.dates.year = new Date().getFullYear()
  },
  methods: {
    openEticket(info) {
      if (this.show != info.number) {
        this.show = info.number
        
				axios.get(`${this.settings.apiBookingBarakaTexnika}/E_Ticket/GetClientTickets?branchId=${this.$route.params.id}&number=${info.number}`)
					.then((response) => {
						this.status = response.data.Status
						if (this.status == 3) {
							this.deleteTicket(info)
						}
					})
					.catch((error) => console.log(error))
        
      }
      else {
        this.show = 0
        this.status = ''
      }
    },
    openBooking(info) {
      if (this.show != info.number) {
        this.show = info.number
				axios.get(`${this.settings.apiBookingBarakaTexnika}/Bookings/GetClientBookings?bookingNumber=${info.number}&clientId=1`)
					.then((response) => {
						this.status = response.data.Status
						if (response.data.Code == -1) {
							this.deleteBooking(info)
						}
					})
					.catch((error) => console.log(error))
      }
      else {
        this.show = 0
        this.status = ''
      }
    },
    async loadeTicket() {
      this.eTicket = await JSON.parse(localStorage.eticket)
    },
    deleteTicket(info) {
      this.isActiveToolTip = true
			
			axios
				.post(`${this.settings.apiBookingBarakaTexnika}/E_Ticket/DeleteTicket?branchId=${info.branchId}&number=${info.number}`)
				.then((response) => {
					this.isActiveToolTip = response.data.Success
					if (!this.isActiveToolTip || this.status === 3) {
						const infolocalStorge = JSON.parse(localStorage.eticket)
						const info = []
						for (let i = 0; i < infolocalStorge.length; i++) {
							if (infolocalStorge[i].number != info.number) {
								info.push(infolocalStorge[i])
							}
						}
						localStorage.eticket = JSON.stringify(info)
					} else if (this.isActiveToolTip) {
						this.isActiveToolTip = true
						const infolocalStorge = JSON.parse(localStorage.eticket)
						const info = []
						for (let i = 0; i < infolocalStorge.length; i++) {
							if (infolocalStorge[i].number != info.number) {
								info.push(infolocalStorge[i])
							}
						}
						localStorage.eticket = JSON.stringify(info)
					}

					this.loadeTicket()
					setTimeout(() => {
						this.isActiveToolTip = false
					}, 3000)
				})
				.catch((error) => console.log(error))
    },
    async loadBooking() {
      this.booking = await JSON.parse(localStorage.booking)
    },
    deleteBooking(info) {
      this.isActiveToolTip = true
			
			axios
				.post(`${this.settings.apiBookingBarakaTexnika}/Bookings/DeleteBooking?bookingCode=${info.number}&clientId=1&languageShortId=${this.$route.params.lang}&startDate=${moment(info.startDate).format("YYYY-MM-DD")}`)
				.then((response) => {
					if (response.data.Code == 0) {
						const infolocalStorge = JSON.parse(localStorage.booking)
						const infoItem = []
						for (let i = 0; i < infolocalStorge.length; i++) {
							if (infolocalStorge[i].number != info.number) {
								infoItem.push(infolocalStorge[i])
							}
						}
						localStorage.booking = JSON.stringify(infoItem)
						setTimeout(() => {
							this.loadBooking()
							this.isActiveToolTip = false
						}, 3000)
					} else if (response.data.Code == -1) {
						const infolocalStorge = JSON.parse(localStorage.booking)
						const infoItem = []
						for (let i = 0; i < infolocalStorge.length; i++) {
							if (infolocalStorge[i].number != info.number) {
								infoItem.push(infolocalStorge[i])
							}
						}
						localStorage.booking = JSON.stringify(infoItem)
						setTimeout(() => {
							this.loadBooking()
							this.isActiveToolTip = false
						}, 3000)
					}
				})
				.catch((error) => console.log(error))
    }
  },
  created() {
    this.$i18n.locale = this.$route.params.lang
  },
  watch: {
    '$route.params.lang'() {
      this.$i18n.locale = this.$route.params.lang
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.itemActive-h2 {
  padding: 5px;
}

/* .itemActive { */
/* display: none; */
/* } */
.active {
  display: inline-block;
}

.status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
}

.status p {
  font-family: 'Roboto';
  font-size: 18px;
  font-weight: 500;
  color: #263128;
}

.history .list__content .title {
  padding: 0;
}

@media (max-width: 380px) {
  .status p {
    font-size: 15px;
  }
}
</style>